const uatConfig = {
  api: 'https://uat.juicysuite.app/member/api/',
};

export default uatConfig;
